import { render, staticRenderFns } from "./PetCardSection.vue?vue&type=template&id=45a1a89c&scoped=true&"
import script from "./PetCardSection.vue?vue&type=script&lang=js&"
export * from "./PetCardSection.vue?vue&type=script&lang=js&"
import style0 from "./PetCardSection.vue?vue&type=style&index=0&id=45a1a89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1a89c",
  null
  
)

export default component.exports